<template>
<div id="frame">
  <div class="alert alert-warning" v-if="!$online">
      <span>
        <center>
            <v-icon size="25">error</v-icon>
            <b>Bitte stellen Sie eine Internetverbindung her!</b>
            <v-icon size="25">error</v-icon>
        </center>
      </span>
    </div>
  <div v-if="loaded">
    <card :title="subtitle" v-if="tick === 1" id="frame">
      <v-text-field
        v-model="date"
        label="Datum"
        type="date"
        readonly
        >
      </v-text-field>
      <v-text-field
        v-model="time"
        label="Uhrzeit"
        type="time"
        readonly
        >
      </v-text-field>
      <v-text-field
        v-model="name"
        :error-messages="nameErrors"
        label="Ihr Name"
        @input="$v.name.$touch()"
        @blur="$v.name.$touch()"
        required
        readonly
        >
      </v-text-field>
      <v-container v-if="Number(this.$route.query.bereichID) === 1" style="padding: 0">
        <div v-for="checkPoint in checkPoints" v-bind:key="checkPoint.chechPoint">
          <v-list-tile>
            <v-list-tile-action>
              <v-checkbox v-model="checkPoint.check" readonly></v-checkbox>
            </v-list-tile-action>
            {{checkPoint.text}}
          </v-list-tile>
          <v-divider/>
        </div>
        <div class="" v-if="imageState">
          <button class="btn btn-sm btn-secondary" @click="showImageNew()" v-if="!showImageBool">Foto anzeigen</button>
          <button class="btn btn-sm btn-secondary" @click="showImageNew()" v-else>Foto ausblenden</button>
          <div v-if="showImageBool">
            <img v-if="image !== ''" :src="image"/>
          </div>
        </div>
        <v-divider v-if="imageState"/>
      </v-container>
      <v-container v-if="Number(this.$route.query.bereichID) === 2" style="padding: 0">
        <div v-for="checkPoint in checkPoints" v-bind:key="checkPoint.chechPoint">
          <v-list-tile v-if="checkPoint.dayCheck.includes(weekDay)">
            <v-list-tile-action>
              <v-checkbox v-model="checkPoint.check" readonly></v-checkbox>
            </v-list-tile-action>
            {{checkPoint.text}}
          </v-list-tile>
          <v-divider v-if="checkPoint.dayCheck.includes(weekDay)" />
        </div>
      </v-container>
      <v-container v-if="[3, 4].includes(Number(this.$route.query.bereichID))" style="padding: 0">
        <div v-for="checkPoint in checkPoints" v-bind:key="checkPoint.chechPoint">
          <v-list-tile>
            <v-list-tile-action>
              <v-checkbox v-model="checkPoint.check" readonly></v-checkbox>
            </v-list-tile-action>
            {{checkPoint.text}}
          </v-list-tile>
          <v-divider />
        </div>
      </v-container>
      <v-text-field
        v-model="bemerkung"
        label="Bemerkung"
        readonly
        >
      </v-text-field>
      <v-divider/>
      <!-- <v-btn @click="submit">submit</v-btn> -->
      <button class="btn btn-lg btn-danger float-left" v-on:click="goBack('firstCancel')" type="button">zurück</button>
    </card>
  </div>
  <div v-else>
  <center>
      <v-progress-circular
      :size="70"
      :width="7"
      color="red"
      indeterminate
    ></v-progress-circular>
  </center>
  </div>
</div>

</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import navigation from '../../../../../store/navigation';

export default {
mixins: [validationMixin],

validations: {
    name: { required },
},
  data () {
    return {
      auth: "Basic " + window.btoa(process.env.VUE_APP_NODE_AUTH),
      routeBack: [],
      checkPoints:[],
      imageState: false,
      showImageBool: false,
      weekDay: "",
      image: "",
      loaded: false,
      active: true,
      tick: 1,
      title: "Checkliste",
      subtitle: "Checkliste ",
      title2: "Angaben bestätigen",
      date: "",
      time:"",
      name: "",
      signature: "",
      bemerkung: "",
      showErrorMessage: false,
    }
  },
  methods: {
    showImage(index) {
      this.checkPoints[index].showImage = !this.checkPoints[index].showImage;
    },
    showImageNew() {
      this.showImageBool = !this.showImageBool;
    },
    goBack(route) {
      // if (route !== "reinigungsnachweis" && route !== "reinigungsnachweise") {
      //   this.$router.push({path: navigation.createNav(route).path});
      // } else if (route !== "reinigungsnachweis" && route === "reinigungsnachweise") {
      //   this.$router.push({path: navigation.createNav(route).path, query: {bereichID: this.$route.query.bereichID}});
      // }
      if (route === 'firstCancel') {
        this.$router.push({path: '/qs/servicelisten/checklists/' + this.$route.query.bereichID});
      }
    },
    disableNotification(){
      this.showErrorMessage = false;
    },
    cancel(){
      this.tick = 1;
    },
    formatDate(date){
      var today = new Date(date);
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();
      var date = dd+ '.' + mm + '.' + yyyy;
      return date;
    },
    createToday(){
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();
      var date = yyyy+ '-' + mm + '-' + dd;
      this.date = date;
      this.time = (today.getUTCHours()+1) + ':' + today.getUTCMinutes();
    },
    fetchChecklist(){
      console.log("abrufen der Checkliste aus der DB");
      if (Number(this.$route.params.id) === -1) {
        const tmpData = JSON.parse(localStorage.getItem('checklistQS' + this.$route.query.bereichID));
        this.setData(tmpData[this.$route.query.tempID]);
      } else {
        this.$http.get(process.env.VUE_APP_NODE_API_URL+'/heimspiel/qs/checklists/' + this.$route.query.bereichID + '/checklist/'+ this.$route.params.id, { headers: {'Authorization': this.auth }})
        .then(function(response){
          this.setData(response.body.data[0]);
        });
      }
    },
    setData(data) {
      var checklistDate = new Date(data.datum);
      var dd = String(checklistDate.getDate()).padStart(2, '0');
      var mm = String(checklistDate.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = checklistDate.getFullYear();
      var date = yyyy+ '-' + mm + '-' + dd;
      this.weekDay = checklistDate.getDay();
      this.date = date;
      this.time = data.uhrzeit;
      this.name = data.name;
      this.bemerkung = data.bemerkung;
      if (data.image !== null) {
        this.image = data.image;
        this.imageState = true;
      } 
      this.checkPoints.map(checkPoint => {
        checkPoint.check = data[checkPoint.checkPoint];
        checkPoint.image = data['image' + checkPoint.checkPoint.substring(0, 1).toUpperCase() + checkPoint.checkPoint.substring(1)];
        checkPoint.image !== null ? checkPoint.imageState = true : checkPoint.imageState = false;
      });
      this.loaded = true;
    },
    save() {
      this.loading = true;
      this.nextTick();
      let checklist = {
        bereichID: Number(this.$route.query.bereichID),
        datum: this.date,
        uhrzeit: this.time,
        name: this.name,
        bemerkung: this.bemerkung,
      };
      this.checkPoints.map((checkPoint, index) => {
        if(checkPoint.check === false){
          checkPoint.check = 0;
          checklist[checkPoint.checkPoint]= checkPoint.check;
        }else{
          checkPoint.check = 1;
          checklist[checkPoint.checkPoint]= checkPoint.check;
        }
      });
      this.$http.post(process.env.VUE_APP_NODE_API_URL+'/heimspiel/qs/checklist/add', checklist, { headers: {'Authorization': this.auth }})
      .then(function(response) {
        if(response.body.error){
          console.log(response.body.error);
          this.nextTick();
          this.showErrorMessage = true;
          setTimeout(() => this.$router.go(-1), 1500);
        } else {
          this.loading = false;
          setTimeout(() => this.$router.go(-1), 1500);
        }
      });
    }
  },
computed: {
  nameErrors () {
    const errors = []
    if (!this.$v.name.$dirty) return errors
    !this.$v.name.required && errors.push('Bitte geben Sie Ihren Namen ein')
    return errors
  },
},
created: function() {
  this.routeBack = navigation.createNav('reinigungsnachweis').params;
  this.subtitle = this.$route.query.title + " - Checkliste " +  this.$route.params.id;
  if (Number(this.$route.query.bereichID) === 1) {
    this.checkPoints= [
      {checkPoint: 'fleischwolf', check: false, text: 'Fleischwolf gereinigt', imageState: false, image: '', showImage: false},
      {checkPoint: 'arbeitsgeraete', check: false, text: 'Arbeitsgeräte gereinigt', imageState: false, image: '', showImage: false},
      {checkPoint: 'grill', check: false, text: 'Grill, Herd & Friteuse gereinigt', imageState: false, image: '', showImage: false},
      {checkPoint: 'arbeitsflaeche', check: false, text: 'Arbeitsflächen gereinigt', imageState: false, image: '', showImage: false},
      {checkPoint: 'fussboden', check: false, text: 'Fußboden und Abläufe gereinigt', imageState: false, image: '', showImage: false},
      {checkPoint: 'waende', check: false, text: 'Wände und Türen gereinigt', imageState: false, image: '', showImage: false},
      {checkPoint: 'theken', check: false, text: 'Theken Innenbereich gereinigt', imageState: false, image: '', showImage: false},
      {checkPoint: 'spuelmaschine', check: false, text: 'Spülmaschine gereinigt', imageState: false, image: '', showImage: false},
      {checkPoint: 'kuehlhausf', check: false, text: 'Kühlhaus Fleisch gereinigt', imageState: false, image: '', showImage: false},
      {checkPoint: 'kuehlhausw', check: false, text: 'Kühlhaus Wurst gereinigt', imageState: false, image: '', showImage: false},
      {checkPoint: 'kuehlhausk', check: false, text: 'Kühlhaus Käse gereinigt', imageState: false, image: '', showImage: false},
    ];
    this.fetchChecklist();
  } else if(Number(this.$route.query.bereichID) === 2) {
    this.checkPoints = [
      {checkPoint: 'thekeScheibe', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Thekenscheiben sind geputzt'},
      {checkPoint: 'thekeSchraenke', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Schränke sind an der Frontseite feucht abgewischt'},
      {checkPoint: 'thekeWaagen', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Waagen sind feucht abgewischt und desinfiziert'},
      {checkPoint: 'thekeMaterial', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Das Material wurde aufgefüllt'},
      {checkPoint: 'thekeOfen', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Der Warmhalteofen ist gereinigt'},
      {checkPoint: 'thekeAblage', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Ablageflächen sind feucht abgewischt und desinfiziert'},
      {checkPoint: 'thekePreis', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Preisschilder sind feucht abgewischt'},
      {checkPoint: 'thekeStecher', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Der Stecher und die Schneide-Bretter sind gespült'},
      {checkPoint: 'thekeSchuesseln', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Alle Schüsseln nicht benötigten Schüsseln sind gespült und stehen nicht auf der Theke (bitte unter den Tisch räumen)'},
      {checkPoint: 'thekeFleisch', check: false, dayCheck: [6, 0],  text: 'Die Fleischtheke ist ausgeräumt und ausgewischt	(Samstag)'},
      {checkPoint: 'thekeAbfluesse', check: false, dayCheck: [6, 0],  text: 'Die Abflüsse in der Fleischtheke wurden heiss gespült und sind frei (Samstag)'},
      {checkPoint: 'thekeMesser', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Messer & Gehacktes-Stecher sind gereinigt und desinfiziert'},
      {checkPoint: 'thekeHeuer', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Der Heuer ist gereinigt und desinfiziert'},
      {checkPoint: 'thekeKuehlhaus', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Messer, Gehacktes-Stecher und der Heuer liegen im Kühlhaus'},
      {checkPoint: 'thekeGehackte', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Das restliche Gehackte  ist abgeschrieben'},
      {checkPoint: 'thekeRindfleisch', check: false, dayCheck: [6],  text: 'Das hochwertige Rindfleisch wurde mit Schildern vakumiert (Samstag)'},
      {checkPoint: 'thekeLicht', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Das Licht im Bedienungsbereich ist ausgeschaltet'},
      {checkPoint: 'thekeFehlbons', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Fehlbons sind ins Büro gebracht worden'},
      // Vorbereitungsraum
      {checkPoint: 'vorbSaege', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Säge ist zerlegt und gereinigt'},
      {checkPoint: 'vorbEinfuell', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Einfüllschüssel des Wolfs ist desinfiziert'},
      {checkPoint: 'vorbWolf', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Der Wolf ist zerlegt, die Einzelteile sind gespült'},
      {checkPoint: 'vorbAufschnitt', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Aufschnittmaschine ist gereinigt und desinfiziert'},
      {checkPoint: 'vorbTisch', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Der Tisch im Vorbereitungsraum ist gereinigt und desinfiziert'},
      {checkPoint: 'vorbSpuelm', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Spülmaschine ist abgepumpt & innen ausgewischt'},
      {checkPoint: 'vorbSteht', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Es steht nichts auf der Spülmaschine'},
      {checkPoint: 'vorbSieb', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Das Sieb in der Spülmaschine ist gereinigt'},
      {checkPoint: 'vorbKartusche', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Das Reinigungsprogramm Backofen ist gestartet (Reinigungskartusche)'},
      {checkPoint: 'vorbOfen', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Der Ofen ist von außen feucht abgewischt & desinfiziert'},
      {checkPoint: 'vorbAblauf', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Ablaufgitter und der Boden sind sauber'},
      {checkPoint: 'vorbTuer', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Tür (Vorbereitung/Verkauf) ist feucht abgewischt'},
      {checkPoint: 'vorbMuell', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Der Müll ist entsorgt & neue Tüte eingesetzt'},
      // Lager
      {checkPoint: 'lagerLeergut', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Das Leergut im Lagerraum ist gestapelt'},
      {checkPoint: 'lagerVerraeumt', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Betriebsmittel/Tüten sind alle verräumt'},
      {checkPoint: 'lagerLappen', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Es hängen keine Lappen/Schürzen/Jacken über dem Geländer'},
      {checkPoint: 'lagerDosen', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Es befindet sich kein Leergut/ Dosen/Flaschen im Lagerbereich'},
      {checkPoint: 'lagerPappen', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Es wurden sämtliche Pappen/leere Verpackungen entsorgt'},
      {checkPoint: 'lagerPutzmittel', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Es stehe keine Reinigungs-Putzmittel herum'},
      {checkPoint: 'lagerSchleif', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Ecke mit der Schleifmaschine ist aufgeräumt (Fleischer)'},
      {checkPoint: 'lagerPC', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Ablage am PC ist aufgeräumt'},
      {checkPoint: 'lagerFleischer', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Ablage Edelstahlstisch ist aufgeräumt (Fleischer)'},
      {checkPoint: 'lagerGefegt', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Der Bereich ist gefegt'},
      {checkPoint: 'lagerBesen', check: false, dayCheck: [1, 2, 3, 4, 5, 6, 0],  text: 'Die Besen/Schrubber hängen an der Halterung'},
    ];
    this.fetchChecklist();
  } else if (Number(this.$route.query.bereichID) === 3) {
    this.checkPoints= [
    {checkPoint: 'wurstWare', check: false, text: 'Die Stückware wurde aufgefüllt'},
    {checkPoint: 'wurstMat', check: false, text: 'Das Material wurde aufgefüllt'},
    {checkPoint: 'wurstAnsch', check: false, text: 'Die Anschnitte wurden auf Bleche gepackt'},
    {checkPoint: 'wurstBrett', check: false, text: 'Die Bretter und Messer wurden gereinigt und desinfiziert'},
    {checkPoint: 'wurstAufsch', check: false, text: 'Die Aufschnittmaschine wurde gereinigt und desinfiziert'},
    {checkPoint: 'wurstLose', check: false, text: 'Die lose Wurst, Frikadellen und Würstchen wurden in Tüten gepackt'},
    {checkPoint: 'wurstSalat', check: false, text: 'Die Salate wurden abgedeckt'},
    {checkPoint: 'wurstWaage', check: false, text: 'Die Waagen wurden gereinigt und desinfiziert'},
    {checkPoint: 'wurstAblage', check: false, text: 'Die Ablageflächen der Theke sind feucht abgewischt und desinfiziert'},
    {checkPoint: 'wurstSchrae', check: false, text: 'Die Schränke sind an der Frontseite feucht abgewischt'},
    {checkPoint: 'wurstAblagSch', check: false, text: 'Die Ablageflächen der Schränke sind gereinigt und desinfiziert'},
    {checkPoint: 'wurstMuell', check: false, text: 'Die Müllklappen sind gereinigt'},
    {checkPoint: 'wurstSchink', check: false, text: 'Der Schinken und die Dauerwurst sind foliert auf Bleche gepackt'},
    {checkPoint: 'wurstTonne', check: false, text: 'Die Frischwurst und das Kasseler wurden in die Wursttonne gepackt'},
    {checkPoint: 'wurstTheke', check: false, text: 'Die Wurstheke wurde feucht ausgewischt'},
    {checkPoint: 'wurstEnts', check: false, text: 'Der Müll wurde entsorgt'},
    {checkPoint: 'wurstLicht', check: false, text: 'Das Thekenlicht wurde ausgeschaltet'},
    {checkPoint: 'wurstAbschr', check: false, text: 'Die Abschriften wurden in die Listen eingetragen'},
    {checkPoint: 'wurstUmsae', check: false, text: 'Die Umsätze wurden aufgeschrieben und ins Büro gebracht'},
    ];
    this.fetchChecklist();
  } else if (Number(this.$route.query.bereichID) === 4) {
    this.checkPoints= [
      {checkPoint: 'kaesePetr', check: false, text: 'Petrella und Antipasti sind abgedeckt'},
      {checkPoint: 'kaeseSchnitt', check: false, text: 'Der Schnittkäse ist abgedeckt'},
      {checkPoint: 'kaeseSorten', check: false, text: 'Die Käsesorten sind ordentlich eingepackt'},
      {checkPoint: 'kaeseEinschw', check: false, text: 'Das Einschweissgerät wurde ausgeschaltet'},
      {checkPoint: 'kaeseLicht', check: false, text: 'Das Licht im Kühlschrank wurde ausgeschaltet'},
      {checkPoint: 'kaeseBretter', check: false, text: 'Die Bretter und Messer wurden gereinigt und desinfiziert'},
      {checkPoint: 'kaeseMasch', check: false, text: 'Die Käsemaschine wurde gereinigt und desinfiziert'},
      {checkPoint: 'kaeseWaage', check: false, text: 'Die Waagen wurden gereinigt und desinfiziert'},
      {checkPoint: 'kaeseAblage', check: false, text: 'Die Ablageflächen der Theke sind feucht abgewischt und desinfiziert'},
      {checkPoint: 'kaeseSchrae', check: false, text: 'Die Schränke sind an der Frontseite feucht abgewischt'},
      {checkPoint: 'kaeseGeraeumt', check: false, text: 'Die Ablagefläche ist aufgeräumt'},
      {checkPoint: 'kaeseAblSchr', check: false, text: 'Die Ablageflächen der Schränke sind gereinigt und desinfiziert'},
      {checkPoint: 'kaeseMuellkl', check: false, text: 'Die Müllklappen sind gereinigt'},
      {checkPoint: 'kaeseMuell', check: false, text: 'Der Müll wurde entsorgt'},
    ];
    this.fetchChecklist();
  }
},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#frame{
    margin-left: 0%;
    margin-top: 0%;
    padding-left: 0%;
    padding-top: 0%;
    padding-right: 0%;

}
.v-messages__message{
   color: rgb(255, 115, 0);
}
.instruction{
    text-align: center;
    font-weight: bold;
}
.pad{
  border: 2px solid rgb(117, 108, 108);
  border-radius: 5px ;
}
.messstelle{
    font-weight: bold;
    font-size: large;
}
.angaben{
font-size: large;
font-weight: bold;
}

.boldtxt{
  font-weight: bold;
}
img {
  width: 30%;
  margin: auto;
  display: block;
  margin-bottom: 10px;
}

div.fileinputs {
	position: relative;
}

div.fakefile {
	position: absolute;
	top: 0px;
	left: 0px;
	z-index: 1;
}

input.file {
	position: relative;
	text-align: right;
	-moz-opacity: 0;
	filter: alpha(opacity 0);
	opacity: 0;
	z-index: 2;
}
.backBar:hover {
  cursor: pointer;
  text-decoration: underline;
  color: red;
}
.pointer {
  cursor: default;
}
.is--disabled {
  opacity: 0.65;
}
.is--disabled:hover {
  background-color: #cc071e;
}

.buttonMargin {
  margin-left: 5px;
}
img {
  width: 70%;
  margin: auto;
  display: block;
  margin-bottom: 10px;
}

.picture {
  padding-left: 70px;
}

.pictureText {
  font-size: 13px;
}
</style>

